import React, { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import { useSelector } from "react-redux";

// themes
import { tableDarkTheme, tableLightTheme } from "../../utils/themes.mui";

function DashboardTable({ className, columns, rows }) {
  const theme = useSelector((state) => state.theme);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <ThemeProvider theme={theme === "dark" ? tableDarkTheme : tableLightTheme}>
      <div className="mt-6 overflow-hidden rounded-md bg-brand-card">
        <TableContainer className="px-4">
          <Table stickyHeader aria-label="sticky table">
            <thead className="bg-brand-card text-brand-text">
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </thead>
            <TableBody className="text-brand-text">
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.code}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];

                        if (column.id === "action") {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              <Button
                                variant="contained"
                                color="error"
                                onClick={value.handlerFunction}
                              >
                                {value.value}
                              </Button>
                            </TableCell>
                          );
                        } else if (column.id === "earned") {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format(value)}{" "}
                              {row.pending ? "(pending)" : ""}
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "status" ? (
                              <div
                                className={`p-[2px] ${
                                  value === "unpaid"
                                    ? "bg-[#AD1418]"
                                    : "bg-[#14ad44]"
                                } rounded-full`}
                              >
                                {" "}
                                <span>{value}</span>{" "}
                              </div>
                            ) : column.format && typeof value === "number" ? (
                              column.format(value)
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </ThemeProvider>
  );
}

export default DashboardTable;
